export default __webpack_public_path__ + "static/media/csi_ad_inactive.505baf3d.svg";